(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('tokensFilter', tokensFilter);

    /** @ngInject */
    function tokensFilter() {
        return function(text) {
			switch (text) {
				case 'R2W':
					return 'R2W';
				default:
					return 'LOCALE_TOKEN';
			}
        };
    }

})();
